// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"bc28d989","737":"8a70c25c"}[chunkId] + ".chunk.js";
};